export enum PatientConsentType {
    processPersonalAndMedicalData = 'processPersonalAndMedicalData',
    shareDataWithExternalPartyForPrem = 'shareDataWithExternalPartyForPrem',
}
